const actionTypes = require('constants/contactCenter/actionTypes');
const { APIPost } = require('utilities/APIRequestHelper');

const raiseToN2Request = () => (dispatch) => {
    dispatch({
        type: actionTypes.RAISE_TO_N2_REQUEST,
        payload: {
            isFetching: true
        }
    });
};

const raiseToN2Success = (response) => (dispatch) => {
    dispatch({
        type: actionTypes.RAISE_TO_N2_SUCCESS,
        payload: response
    });
};

const raiseToN2Failure = (error) => (dispatch) => {
    dispatch({
        type: actionTypes.RAISE_TO_N2_FAILURE,
        payload: error.body
    });
};

const raiseToN2Reset = () => (dispatch) => {
    dispatch({
        type: actionTypes.RAISE_TO_N2_RESET
    });
};

const raiseToN2 = (dispatch, getState) => {
    const signaturePositionsValues = getState().signaturePattern.get('consumerInputDigits').join(" ");
    const dataToken = getState().signaturePattern.get('token');

    const params = {
        query:  {
            dataToken,
            signaturePositionsValues
        }
    };

    dispatch(raiseToN2Request());
    APIPost({ dispatch, endpoint: 'raiseInteractionN2', params })
        .then(response => dispatch(raiseToN2Success(response)))
        .catch(error => dispatch(raiseToN2Failure(error)));
};


module.exports = {
    raiseToN2,
    raiseToN2Reset
};
